"use client";

import React, { MouseEventHandler } from "react";
import styled from "styled-components";

import Box from "../Box";
import StretchingAsset from "../StretchingAsset";
import { getColor } from "../utils";
import { AssetType } from "../../constants/types";
import { AnyObject, Asset } from "../../models";

export const wrapperTestId = "support-image-wrapper";

type SupportingContentItem = {
  id: string | number;
  asset?: Asset;
};

type Props<Item extends SupportingContentItem> = {
  item: Item;
  canEdit?: boolean;
  selected?: boolean;
  onClick?: MouseEventHandler;
};

type WrapperProps = { selected?: boolean; style?: AnyObject; canEdit?: boolean };

const SelectionWrapper = styled(Box).attrs<WrapperProps>(props => {
  return {
    overflow: "hidden",
    borderRadius: "default",
    background: "white",
    border:
      props.selected && props.canEdit
        ? `2px solid ${getColor(props.theme.primaryColor, "primary")}`
        : "2px solid transparent",
  };
})<WrapperProps>``;

const GallerySupportingAsset = <Item extends SupportingContentItem>({
  item,
  selected,
  canEdit,
  onClick,
  ...rest
}: Props<Item>) => {
  if (!item) return null;
  if (!item.asset) {
    console.error(`Expected item ${item.id} to have asset`);
    return null;
  }

  const isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(item.asset.type);
  const imageStyles: React.CSSProperties = isImage ? { pointerEvents: "none" } : {}; // Don't interfere with drag & drop

  return (
    <Box data-testid={wrapperTestId} width="100%" {...rest}>
      <SelectionWrapper onClick={canEdit ? onClick : null} selected={selected} canEdit={canEdit}>
        <StretchingAsset asset={item.asset} style={imageStyles} p="none" />
      </SelectionWrapper>
    </Box>
  );
};

export default GallerySupportingAsset;
